import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3Wide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconColumns3Wide"><Path d="M7.58984 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75C2 4.33579 2.33579 4 2.75 4H7.58984V20Z" fill="currentColor"/><Path d="M14.9102 20H9.08984V4H14.9102V20Z" fill="currentColor"/><Path d="M21.25 4C21.6642 4 22 4.33579 22 4.75V19.25C22 19.6642 21.6642 20 21.25 20H16.4102V4H21.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3Wide;
